/**
 * webRTCConstants.js
 * Talkroute
 *
 * Created by Vel Genov on 6/13/19
 * Copyright (c) 2019 Talkroute. All right reserved.
 */
/* eslint no-undef: off */

import { appConfig } from "../index";

/**
 * A collection of constants used with when connecting
 * to the Talkroute WebRTC server
 */
const webRTCConstants = () => ({
  connection: {
    realm: appConfig.webRTC,
    impi: "",
    impu: appConfig.webRTC,
    password: "",
    displayName: "",
    websocketProxyUrl: `wss://${appConfig.webRTC}/ws`,
  },
  session: {
    timeout: 200,
  },
});

export default webRTCConstants;
